import { supabase } from './supabaseClient';

/**
 * Fetch guest data by endpoint from Supabase
 * @param {string} endpoint - The endpoint to look up
 * @returns {Promise<object|null>} Guest data or null if not found
 * @throws {Error} If Supabase returns an error
 */
export async function fetchGuestByEndpoint(endpoint, { rpcName = 'get_guest_by_endpoint' } = {}) {
  // Validate endpoint is a non-empty string
  if (!endpoint || typeof endpoint !== 'string') {
    return null;
  }

  // Call Supabase RPC
  const { data, error } = await supabase.rpc(rpcName, {
    p_endpoint: endpoint,
  });

  // Throw error if Supabase returns one
  if (error) {
    throw error;
  }

  // RPC returns an array, return first item or null
  return data?.[0] ?? null;
}

/**
 * Submit RSVP response for a guest
 * @param {string} endpoint - The guest endpoint
 * @param {boolean} coming - Whether the guest is coming
 * @param {number} guestCount - Number of guests attending
 * @param {string|null} note - Optional special note
 * @throws {Error} If Supabase returns an error
 */
export async function submitRsvp(endpoint, coming, guestCount, note) {
  const { error } = await supabase.rpc('submit_rsvp', {
    p_endpoint: endpoint,
    p_coming: coming,
    p_guest_count: guestCount,
    p_special_note: note ?? null,
  });

  if (error) {
    throw error;
  }
}
